import { RouteLocationNormalizedLoaded } from "vue-router";
import { generateBreadCrumb } from "@/utilities/breadcrumb";

/**
 * Generates a dynamic title for a specific route based on the breadcrumb of that route.
 *
 * @param {RouteLocationNormalizedLoaded} route - An object containing information about the route's location.
 * @returns {string} - A string representing the generated title.
 */
export const generateDynamicTitle = (route: RouteLocationNormalizedLoaded): string => {
  const { t: $t } = useI18n();

  const breadCrumbArray = generateBreadCrumb(route) || [];

  if (breadCrumbArray.length > 0) {
    breadCrumbArray[0] = $t(`${breadCrumbArray[0]}`);
  }

  const formattedBreadCrumb = breadCrumbArray
    .map((word) => word[0]?.toUpperCase() + word.slice(1).toLocaleLowerCase())
    .reverse()
    .join(" | ");

  return formattedBreadCrumb ? `${formattedBreadCrumb} - ${$t("title")}` : $t("title");
};
